"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = require("underscore");

var _BaseDialog = _interopRequireDefault(require("customer-data-ui-utilities/dialog/BaseDialog"));

var _ComponentWithWindowListeners = _interopRequireDefault(require("UIComponents/mixins/ComponentWithWindowListeners"));

var _hubspot = _interopRequireDefault(require("hubspot.Interframe"));

var _classnames = _interopRequireDefault(require("classnames"));

var IFRAME_MARGIN = 60;
var IFRAME_HEADER = 68;
var IFRAME_PADDING = 40;
var MODAL_MIN_WIDTH = 150;

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIframeModal',
  mixins: [_ComponentWithWindowListeners.default],
  propTypes: {
    closeIframeModal: _propTypes.default.func.isRequired,
    footer: _propTypes.default.node,
    height: _propTypes.default.number,
    onCancelInterframeMessage: _propTypes.default.func,
    onDoneInterframeMessage: _propTypes.default.func,
    onReject: _propTypes.default.func,
    title: _propTypes.default.string,
    uri: _propTypes.default.string.isRequired,
    width: _propTypes.default.number
  },
  getInitialState: function getInitialState() {
    return {
      windowWidth: (0, _jquery.default)(window).width(),
      windowHeight: (0, _jquery.default)(window).height()
    };
  },
  componentDidMount: function componentDidMount() {
    return this.setupInterframe();
  },
  getWindowListeners: function getWindowListeners() {
    this.debouncedHandleResize = (0, _underscore.debounce)(this.handleResize, 100);
    return {
      resize: this.debouncedHandleResize
    };
  },
  handleResize: function handleResize() {
    return this.setState({
      windowWidth: (0, _jquery.default)(window).width(),
      windowHeight: (0, _jquery.default)(window).height()
    });
  },
  getIframeWidth: function getIframeWidth() {
    var width = this.props.width;
    var maxWidth = this.state.windowWidth - 2 * IFRAME_MARGIN - 2 * IFRAME_PADDING;

    if (width && width <= maxWidth) {
      return width;
    }

    return maxWidth;
  },
  getIframeHeight: function getIframeHeight() {
    var height = this.props.height;
    var maxHeight = this.state.windowHeight - 2 * IFRAME_MARGIN - IFRAME_HEADER - 2 * IFRAME_PADDING;

    if (height && height <= maxHeight) {
      return height;
    }

    return maxHeight;
  },
  getModalWidth: function getModalWidth() {
    return Math.max(this.getIframeWidth() + 2 * IFRAME_PADDING, MODAL_MIN_WIDTH);
  },
  getUri: function getUri() {
    var uri = this.props.uri;
    return uri + "#" + document.location.origin;
  },
  setupInterframe: function setupInterframe() {
    var $iframe = (0, _jquery.default)(this._integrationsIframe);
    var interframe = new _hubspot.default(this.getUri(), $iframe.get(0).contentWindow, true);
    interframe.start();
    return (0, _jquery.default)(interframe).on('message', this.handleIframeMessage);
  },
  handleReject: function handleReject() {
    var _this$props = this.props,
        closeIframeModal = _this$props.closeIframeModal,
        onReject = _this$props.onReject;

    if (typeof onReject === 'function') {
      onReject();
    }

    return closeIframeModal();
  },
  handleIframeMessage: function handleIframeMessage(_, message) {
    var _this$props2 = this.props,
        closeIframeModal = _this$props2.closeIframeModal,
        onCancelInterframeMessage = _this$props2.onCancelInterframeMessage,
        onDoneInterframeMessage = _this$props2.onDoneInterframeMessage;

    switch (message.action) {
      case 'CANCEL':
        if (typeof onCancelInterframeMessage === 'function') {
          onCancelInterframeMessage();
        }

        return closeIframeModal();

      case 'DONE':
        if (typeof onDoneInterframeMessage === 'function') {
          onDoneInterframeMessage();
        }

        return closeIframeModal();

      default:
        return undefined;
    }
  },
  render: function render() {
    var _this = this;

    var _this$props3 = this.props,
        footer = _this$props3.footer,
        title = _this$props3.title;
    var src = this.getUri();
    var sandbox = ['allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox'];

    if (src.startsWith('https://tools.hubteam')) {
      sandbox.push('allow-top-navigation');
    }

    return _react.default.createElement(_BaseDialog.default, {
      onReject: this.handleReject,
      onConfirm: function onConfirm() {},
      showCancelButton: false,
      showConfirmButton: false,
      title: title,
      width: this.getModalWidth(),
      dialogClassName: (0, _classnames.default)({
        'p-bottom-10': !footer
      }),
      includeFooter: footer != null,
      extraFooter: footer
    }, _react.default.createElement("iframe", {
      className: "integrations-iframe",
      src: src,
      ref: function ref(_ref) {
        _this._integrationsIframe = _ref;
      },
      sandbox: sandbox.join(' '),
      style: {
        height: this.getIframeHeight(),
        width: this.getIframeWidth()
      }
    }));
  }
});

exports.default = _default;
module.exports = exports.default;